/**
 * GMA-1619 (CompassCare Web 4/14) — Alerts route container.
 *
 * Mounts the app-shell (WebShell) around the Alerts response queue
 * (AlertsPage) at /web/alerts, wiring sidebar navigation to the router. This
 * is the route scaffolding: the live alert feed (real alerts from the API) is
 * a deliberate follow-up, so until then the page renders the demo queue in
 * demo builds and its fail-safe empty queue otherwise, inside a real,
 * navigable frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import AlertsPage from "./AlertsPage";
import { DEMO_DATA_ENABLED, getDemoAlerts } from "./demoData";

export default function WebAlertsRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so demo-alert generation and the `now` prop agree —
  // relative-time UI drifts if each call reads the clock separately.
  const now = Date.now();
  const alerts = DEMO_DATA_ENABLED ? getDemoAlerts(now) : [];
  return (
    <WebShell
      activeKey="alerts"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Alerts"
    >
      <AlertsPage alerts={alerts} now={now} />
    </WebShell>
  );
}
